import { mfeEnvHom } from './mfe-env/hom';

export const environment = {
	hostname: 'HOM',
	production: true,
	hom: true,
	cloudfrontMfeBaseUrl: 'https://microfrontend.hom.cloud.itau.com.br',
	fullstoryId: 'o-24AF8W-na1',
	googleTagManagerId: 'GTM-NGLB69RB',
	sdkAnalyticsUrl: 'https://www.itau.com.br/sdk-analytics/index.js',
	boRegisterBff: 'https://backoffice.api-sp.hom.aws.cloud.ihf/backoffice-gtw-new/v1',
	boLoginBff: 'https://login-internetbankingglobal-api-hom.cloud.itau.com.br/login-api/v1',
	wireTransferApi:
		'https://wiretransfer-internetbankingglobal-api-hom.cloud.itau.com.br/wiretransfer-api/v1',
	dataDog: {
		env: 'hom',
		name: 'JI8-private-offshore-backoffice',
		version: '1.0.0',
		sigla: 'JI8',
		externalApplication: false,
		datadog: {
			logs: {
				clientToken: 'JI8-private-offshore-backoffice-browser', //pub12257c41b049a9bbb396898816ddaf64
			},
			rum: {
				applicationId: 'bc8e4182-fbd6-4577-82c2-fe3c6622448b',
				clientToken: 'JI8-private-offshore-backoffice-browser', //pub12257c41b049a9bbb396898816ddaf64
			},
		},
	},
	apiRoutes: {
		login: '/login',
		logout: '/logout',
		reset: '/login/password/reset',
		customerBankers: '/customer/bankers',
		forgot: '/login/password/forgot',
		internalUserExcel: '/internal-user/download-excel',
		customer: '/customer',
		customerContainer: '/customer/container',
		customerContainers: '/customer/containers',
		supportResendInvite: '/support/resend-invite',
		resendOtp: '/support/resend-otp',
		supportForgotPassword: '/support/password/forgot',
		customerLanguages: '/customer/languages',
		customerStatus: '/customer/status',
		customerDetails: '/customer/$/detail',
		registerCheckEmail: '/register/email-checker/$',

		customerDetailContainer: '/customer/$/containers',
		revokeContainer: '/customer/$/container/$',
		customerContainerRelationShipByContainer: '/customer/container/$/relationship-party',
		customerContainerRelationShip: '/customer/container/relationship-party',
		wireTransferAccountPermission: '/wire-transfer-account-permission',
		requestManagement: '/request-management',
		requestManagementDetail: '/request-management/$/detail',
		requestManagementApproveOrReject: '/request-management/$',
		requestManagementStatus: '/request-management/status',
		authorizationGroup: '/authorization/groups',
		authorizationRoles: '/authorization/roles',
		internalUserUnits: '/internal-user/units',
		internalUserUnitsPermission: '/internal-user/units/permission',
		internalUser: '/internal-user',
		internalUserBankers: '/internal-user/bankers',
		internalUserDetail: '/internal-user/$/detail',
		internalUserStatus: '/internal-user/status',
		authorizationRolesForUser: '/authorization/user/$/roles',
		queueWiretransfer: '/queue-transfer',
		queueWiretransferAccountClientName: '/queue-transfer/account-client-name',
		queueWiretransferHistory: '/queue-transfer/history',
		queueWiretransferComment: '/queue-transfer/comment',
		queueWiretransferSetStatus: '/queue-transfer/$',
		queueWiretransferDetail: '/queue-transfer/detail',
		queueWiretransferStatus: '/wire-transfer/status',
		wireTransferTimeline: '/queue-transfer/timeline',
		wireTransferSetManualProcessing: '/queue-transfer/set-status-manual-processing',
		documentsContainers: '/documents/containers',
		documentsHistory: '/documents/history',
		customerMigration: '/customer/migration',
		dashboardStatus: '/dashboard/customer-status',
		dashboardCustomerTotalApproved: '/dashboard/customer-total-approved',
		dashboardCustomerCountByBanker: '/dashboard/customer-count-by-banker',
		dashboardBankers: '/dashboard/bankers',
		accordionContainersList: '/customer/$/container-simple',
		accordionContainerRelationShip: '/customer/$/container/$/relationship-account',
		enableMirrorView: '/support/mirror-view',
	},
	...mfeEnvHom,
};
